import { UPDATE, DELETE } from 'react-admin';
import firebase from 'firebase';
import {
  CONTRIBUTION_APPROVE,
  DELETE_CONTRIBUTION,
  UPDATE_CONTRIBUTION_END_DATE,
  UPDATE_CONTRIBUTION_STATE_WHEN_MASTER
} from '../redux/actionTypes';

export const contributionApprove = (data, missionId, basePath) => {
  const { missionId: _, ...pushableData } = data;
  return {
    type: CONTRIBUTION_APPROVE,
    payload: {
      id: data.id,
      data: {
        ...pushableData,
        state: 'approved'
      },
      missionId
    },
    meta: {
      resource: `/missions/${missionId}/contributions`,
      fetch: UPDATE,
      cancelPrevious: false,
      onSuccess: {
        notification: {
          body: 'contributions.approved_success',
          level: 'info'
        }
        //redirectTo: `/missions/${missionId}/show/1`,
        //basePath,
      },
      onFailure: {
        notification: {
          body: 'contributions.approved_failure',
          level: 'warning'
        }
      },
      refresh: true
    }
  };
};

export const deleteContributionFromMission = (data, missionId, basePath) => {
  const { missionId: _, ...pushableData } = data;

  return {
    type: DELETE_CONTRIBUTION,
    payload: {
      id: data.id,
      previousData: {
        ...pushableData
      },
      missionId
    },
    meta: {
      resource: `/missions/${missionId}/contributions`,
      fetch: DELETE,
      cancelPrevious: false,
      onSuccess: {
        notification: {
          body: 'contributions.delete_success',
          level: 'info'
        },
        callback: ({ payload, requestPayload }) => {
          deleteContributionFromUser(payload.data, requestPayload.missionId);
        }
      },
      onFailure: {
        notification: {
          body: 'contributions.delete_failure',
          level: 'warning'
        }
      },
      refresh: true
    }
  };
};

const deleteContributionFromUser = (data, missionId) => {
  const { userId } = data;

  const getSelectedUser = () =>
    new Promise((res, rej) => {
      return firebase
        .database()
        .ref(`users/${userId}`)
        .once('value')
        .then(snapshot => res(snapshot.val()))
        .catch(rej);
    });

  const selectedUser = getSelectedUser();

  return selectedUser.then(user => {
    if (user) user.missionIds = user.missionIds.filter(id => missionId !== id);

    return firebase
      .database()
      .ref(`users/${userId}`)
      .update(user)
      .then(_ => {
        console.log('User updated with Success');
        return { data: user };
      });
  });
};

export const editContributionEnd = (newEndDate, missionId, contributionId) => {
  return {
    type: UPDATE_CONTRIBUTION_END_DATE,
    payload: {
      id: contributionId,
      data: {
        id: contributionId,
        end: newEndDate
      },
      missionId,
      contributionId
    },
    meta: {
      resource: `/missions/${missionId}/contributions/`,
      fetch: UPDATE,
      cancelPrevious: false,
      onSuccess: {
        notification: {
          body: 'contributions.edit_success',
          level: 'info'
        }
        //redirectTo: `/missions/${missionId}/show/1`,
        //basePath,
      },
      onFailure: {
        notification: {
          body: 'contributions.edit_failure',
          level: 'warning'
        }
      },
      refresh: true
    }
  };
};

export const editContributionStateWhenMasterAction = (
  missionId,
  contributionId,
  newState
) => {
  return {
    type: UPDATE_CONTRIBUTION_STATE_WHEN_MASTER,
    payload: {
      id: contributionId,
      data: {
        id: contributionId,
        state: newState
      }
    },
    meta: {
      resource: `/missions/${missionId}/contributions/`,
      fetch: UPDATE,
      cancelPrevious: false,
      onSuccess: {
        notification: {
          body: 'contributions.edit_success',
          level: 'info'
        }
        //redirectTo: `/missions/${missionId}/show/1`,
        //basePath,
      },
      onFailure: {
        notification: {
          body: 'contributions.edit_failure',
          level: 'warning'
        }
      },
      refresh: true
    }
  };
};



// WEBPACK FOOTER //
// ./src/contributions/contributionActions.js